/* tslint:disable */
/* eslint-disable */
/**
 * Rapurc API-spec
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LocalizedValue,
    LocalizedValueFromJSON,
    LocalizedValueFromJSONTyped,
    LocalizedValueToJSON,
    Metadata,
    MetadataFromJSON,
    MetadataFromJSONTyped,
    MetadataToJSON,
} from './';

/**
 * EWC (European Waste Code) category object
 * @export
 * @interface WasteCategory
 */
export interface WasteCategory {
    /**
     * 
     * @type {string}
     * @memberof WasteCategory
     */
    readonly id?: string;
    /**
     * Localized waste category names
     * @type {Array<LocalizedValue>}
     * @memberof WasteCategory
     */
    localizedNames: Array<LocalizedValue>;
    /**
     * First four characters of EWC code
     * @type {string}
     * @memberof WasteCategory
     */
    ewcCode: string;
    /**
     * 
     * @type {Metadata}
     * @memberof WasteCategory
     */
    metadata: Metadata;
}

export function WasteCategoryFromJSON(json: any): WasteCategory {
    return WasteCategoryFromJSONTyped(json, false);
}

export function WasteCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): WasteCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'localizedNames': ((json['localizedNames'] as Array<any>).map(LocalizedValueFromJSON)),
        'ewcCode': json['ewcCode'],
        'metadata': MetadataFromJSON(json['metadata']),
    };
}

export function WasteCategoryToJSON(value?: WasteCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'localizedNames': ((value.localizedNames as Array<any>).map(LocalizedValueToJSON)),
        'ewcCode': value.ewcCode,
        'metadata': MetadataToJSON(value.metadata),
    };
}


